var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8H4.25C4.64782 8 5.02936 8.15804 5.31066 8.43934C5.59196 8.72064 5.75 9.10218 5.75 9.5V13.25C5.75 13.6478 5.59196 14.0294 5.31066 14.3107C5.02936 14.592 4.64782 14.75 4.25 14.75H2C1.60218 14.75 1.22064 14.592 0.93934 14.3107C0.658035 14.0294 0.5 13.6478 0.5 13.25V8C0.5 3.85775 3.85775 0.5 8 0.5C12.1423 0.5 15.5 3.85775 15.5 8V13.25C15.5 13.6478 15.342 14.0294 15.0607 14.3107C14.7794 14.592 14.3978 14.75 14 14.75H11.75C11.3522 14.75 10.9706 14.592 10.6893 14.3107C10.408 14.0294 10.25 13.6478 10.25 13.25V9.5C10.25 9.10218 10.408 8.72064 10.6893 8.43934C10.9706 8.15804 11.3522 8 11.75 8H14C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2ZM2 9.5V13.25H4.25V9.5H2ZM11.75 9.5V13.25H14V9.5H11.75Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.0e34f62d741cf8653bf001e551d1f4cc.svg";
export { ForwardRef as ReactComponent };